// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.color-icon-settings {
  color: rgba(0, 0, 0, 0.54) !important;
}

.toolbar {
  background: linear-gradient(to bottom, #cccccc, #fbfbfb);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  height: 48px;
  display: flex;
  flex-direction: row;
}

.flag-icon {
  border-radius: 100%;
}

a:hover {
  text-decoration: none;
}

.list-horizontal {
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
}
.list-horizontal a {
  display: flex !important;
  border-radius: 0px;
}
.list-horizontal ::ng-deep .mat-mdc-list-item-unscoped-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

mat-nav-list.list-horizontal {
  padding: 0;
  height: 100%;
}
mat-nav-list.list-horizontal .mat-mdc-list-item {
  display: inline-block;
  height: 100%;
  width: auto;
  padding-inline: 1.1rem;
}

.icon-active {
  visibility: hidden;
}

.active-list-item {
  background: var(--background-routerActive) !important;
  color: var(--white-font) !important;
}
.active-list-item .icon-active {
  visibility: visible;
  padding-inline: 1px;
}
.active-list-item span, .active-list-item mat-icon {
  color: var(--white-font) !important;
}

.textoItemMenu {
  font-weight: 400;
  font-size: initial;
}

.logo {
  width: 9vw;
  padding-right: 10px;
  text-align: left;
}

.example-spacer {
  flex: 1 1 auto;
}

.contenidoAlerta {
  font-size: smaller;
  font-weight: 400;
  color: var(--color-gray);
}

/* SUBMENU */
.subMenu {
  min-height: 1vh;
  height: 100%;
  background: white;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 13px;
}
.subMenu button {
  padding-top: 0%;
  background: var(--background-routerActive);
  color: white;
  border-radius: 0%;
}
.subMenu .active-tab {
  background-color: var(--background-routerActive-submenu);
  color: white;
}

::ng-deep .full-width {
  width: 100%;
}
::ng-deep .full-width .mat-form-field-wrapper {
  margin: 0px !important;
  padding: 0 !important;
}

.menu-container {
  height: 30vh;
  width: 280px;
  overflow-y: scroll;
}
.menu-container ::ng-deep .mdc-list-item__end {
  display: none !important;
}

.form__group {
  display: flex;
  justify-content: center;
  margin: 0 10px 10px;
}

.no-results-div {
  font-weight: 500;
  font-size: 1.9rem;
  text-align: center;
  margin-top: 16px;
}

.enviroment-name-text {
  margin-right: 12px;
  font-weight: 500;
  display: flex;
  gap: 12px;
}

.userButton {
  display: flex;
  align-items: center;
  gap: 10px;
}

.textUser {
  min-width: 100px;
  display: flex;
  align-items: start;
  flex-direction: column;
}
.textUser .textUser-name {
  font-size: 14px;
  font-weight: 500;
}
.textUser .textUser-role {
  font-size: 11px;
  color: #6d6d6d;
  text-transform: capitalize;
}

.mat-divider-btns {
  margin: 8px;
  margin-right: 12px;
}

.misAplicaciones {
  width: 50px !important;
  padding-right: 0px;
}

.app-container {
  height: 100%;
}

#id_text_uppercase {
  text-transform: uppercase;
}

.textMenu {
  font-weight: normal;
  text-transform: uppercase;
  cursor: pointer;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

.textMenuSlider {
  font-weight: 500;
  font-size: small;
}

.container-btns {
  display: flex;
}
.container-btns .mat-mdc-slide-toggle {
  margin-right: 1em;
}
.container-btns .slide-div {
  display: flex;
  align-items: center;
  border-right: 1px solid black;
}
.container-btns .btnMunicipio {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
}
.container-btns .btnMunicipio .btn-name-city {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

.btnUser ::ng-deep .mdc-button__label {
  gap: 10px;
  display: flex;
  align-items: flex-end;
}

/* responsive desgin */
@media (max-width: 768px) {
  .iconSession {
    float: right;
  }
  .toolbar {
    background: var(--background-routerActive) !important;
    height: 7vh;
  }
  .logo {
    width: 120px;
    text-align: center;
    margin-left: 6px;
    margin-bottom: 0.3rem;
  }
  .iconMenu {
    color: white;
    transform: scale(1.3);
  }
  .misAplicaciones {
    transform: scale(1.3);
    padding-right: 10px;
  }
  .misAplicaciones mat-icon {
    color: white;
  }
  .txusuario {
    display: block;
    font-size: initial;
    color: var(--font-gray);
  }
  .txmail {
    display: block;
    font-size: xx-small;
    color: var(--font-gray);
  }
  .sidenavItem {
    padding-left: 6%;
    padding-bottom: 5%;
  }
  .sidenavItem .active-tab {
    color: var(--background-routerActive-submenu);
  }
  .menuNav {
    width: 92%;
    color: white;
    display: flex;
    margin-top: 10%;
    justify-content: center;
    background: var(--background-routerActive) !important;
  }
  .container-mat-spinner-icon-location {
    margin-right: 10px;
  }
  .container-mat-spinner-icon-person {
    margin-left: 10px;
  }
  .showOrHide {
    transform: rotate(180deg);
  }
  mat-sidenav-container {
    height: 95%;
  }
  mat-sidenav-container mat-sidenav {
    background-color: rgb(255, 255, 255);
    width: 70%;
  }
  mat-sidenav-container mat-sidenav-content {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/component/header/header.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;;AAEA;EACI,qCAAA;AACJ;;AAEA;EACI,wDAAA;EACA,+GAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AACI;EACI,wBAAA;EACA,kBAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;;AAIA;EACI,UAAA;EACA,YAAA;AADJ;AAEI;EACE,qBAAA;EACA,YAAA;EACE,WAAA;EACA,sBAAA;AAAR;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,qDAAA;EACA,mCAAA;AADJ;AAEI;EACI,mBAAA;EACA,mBAAA;AAAR;AAGI;EACI,mCAAA;AADR;;AAKA;EACI,gBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,wBAAA;AAFJ;;AAKA,YAAA;AAEA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AAHJ;AAII;EACI,eAAA;EACA,0CAAA;EACA,YAAA;EACA,iBAAA;AAFR;AAKI;EACI,wDAAA;EACA,YAAA;AAHR;;AAQA;EACI,WAAA;AALJ;AAOK;EACG,sBAAA;EACA,qBAAA;AALR;;AASA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;AANJ;AAQI;EACI,wBAAA;AANR;;AAUA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;AAPJ;;AAUA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AAPJ;AASI;EACI,eAAA;EACA,gBAAA;AAPR;AAUI;EACI,eAAA;EACA,cAAA;EACA,0BAAA;AARR;;AAYA;EACI,WAAA;EACA,kBAAA;AATJ;;AAYA;EACI,sBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,YAAA;AATJ;;AAYA;EACI,yBAAA;AATJ;;AAYA;EACI,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;AATJ;;AAYA;EACI,gBAAA;EACA,gBAAA;AATJ;;AAYA;EACI,aAAA;AATJ;AAUI;EACI,iBAAA;AARR;AAWI;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AATR;AAWI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AATR;AAWQ;EACI,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AATZ;;AAeI;EACI,SAAA;EACA,aAAA;EACA,qBAAA;AAZR;;AAgBA,sBAAA;AACA;EAGI;IACI,YAAA;EAfN;EAkBE;IACI,qDAAA;IACA,WAAA;EAhBN;EAkBE;IACI,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;EAhBN;EAkBE;IACI,YAAA;IACA,qBAAA;EAhBN;EAmBE;IACI,qBAAA;IACA,mBAAA;EAjBN;EAmBM;IACI,YAAA;EAjBV;EAqBE;IACI,cAAA;IACA,kBAAA;IACA,uBAAA;EAnBN;EAsBE;IACI,cAAA;IACA,mBAAA;IACA,uBAAA;EApBN;EAuBE;IACI,gBAAA;IACA,kBAAA;EArBN;EAuBM;IACI,6CAAA;EArBV;EAyBE;IACI,UAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;IACA,uBAAA;IACA,qDAAA;EAvBN;EA0BE;IACI,kBAAA;EAxBN;EA2BE;IACI,iBAAA;EAzBN;EA4BE;IACI,yBAAA;EA1BN;EA6BE;IACI,WAAA;EA3BN;EA4BM;IACI,oCAAA;IACA,UAAA;EA1BV;EA4BM;IACI,WAAA;EA1BV;AACF","sourcesContent":[".page-content{\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100vh;\r\n}\r\n\r\n.color-icon-settings {\r\n    color: rgba(0, 0, 0, 0.54) !important;\r\n}\r\n\r\n.toolbar {\r\n    background: linear-gradient(to bottom, #cccccc, #fbfbfb);\r\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\r\n    height: 48px;\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.flag-icon {\r\n    border-radius: 100%;\r\n}\r\n\r\na:hover{\r\n    text-decoration: none;\r\n}\r\n\r\n.list-horizontal{\r\n    display: flex !important;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    flex-wrap: nowrap;\r\n\r\n    a {\r\n        display: flex !important;\r\n        border-radius: 0px;\r\n    }\r\n\r\n    ::ng-deep .mat-mdc-list-item-unscoped-content{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\nmat-nav-list.list-horizontal {\r\n    padding: 0;\r\n    height: 100%;\r\n    .mat-mdc-list-item {\r\n      display: inline-block;\r\n      height: 100%;\r\n        width: auto;\r\n        padding-inline: 1.1rem;\r\n    }\r\n}\r\n\r\n.icon-active{\r\n    visibility:hidden;\r\n}\r\n\r\n.active-list-item {\r\n    background: var(--background-routerActive) !important;\r\n    color: var(--white-font) !important;\r\n    .icon-active{\r\n        visibility: visible;\r\n        padding-inline: 1px;\r\n    }\r\n\r\n    span, mat-icon{\r\n        color: var(--white-font) !important;\r\n    }\r\n}\r\n\r\n.textoItemMenu {\r\n    font-weight: 400;\r\n    font-size: initial;\r\n}\r\n\r\n.logo {\r\n    width: 9vw;\r\n    padding-right: 10px;\r\n    text-align: left;\r\n}\r\n\r\n.example-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.contenidoAlerta {\r\n    font-size:smaller;\r\n    font-weight: 400;\r\n    color: var(--color-gray);\r\n}\r\n\r\n/* SUBMENU */\r\n\r\n.subMenu{\r\n    min-height: 1vh;\r\n    height: 100%;\r\n    background: white;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding-bottom: 13px;\r\n    button{\r\n        padding-top: 0%;\r\n        background: var(--background-routerActive) ;\r\n        color: white;\r\n        border-radius: 0%;\r\n    }\r\n\r\n    .active-tab{\r\n        background-color: var(--background-routerActive-submenu);\r\n        color: white;\r\n    }\r\n    \r\n}\r\n\r\n::ng-deep .full-width {\r\n    width: 100%;\r\n     \r\n     .mat-form-field-wrapper {\r\n        margin: 0px !important;\r\n        padding: 0 !important;\r\n    }\r\n}\r\n\r\n.menu-container {\r\n    height: 30vh;\r\n    width: 280px;\r\n    overflow-y: scroll;\r\n\r\n    ::ng-deep .mdc-list-item__end{\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n.form__group {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 0 10px 10px;\r\n}\r\n\r\n.no-results-div {\r\n    font-weight: 500;\r\n    font-size: 1.9rem;\r\n    text-align: center;\r\n    margin-top: 16px;\r\n}\r\n\r\n.enviroment-name-text {\r\n    margin-right: 12px;\r\n    font-weight: 500;\r\n    display: flex;\r\n    gap: 12px;\r\n}\r\n\r\n.userButton {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.textUser {\r\n    min-width: 100px;\r\n    display: flex;\r\n    align-items: start;\r\n    flex-direction: column;\r\n\r\n    .textUser-name {\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .textUser-role {\r\n        font-size: 11px;\r\n        color: #6d6d6d;\r\n        text-transform: capitalize;\r\n    }\r\n}\r\n\r\n.mat-divider-btns {\r\n    margin: 8px;\r\n    margin-right: 12px;\r\n}\r\n\r\n.misAplicaciones{\r\n    width: 50px !important;\r\n    padding-right: 0px;\r\n}\r\n\r\n.app-container{\r\n    height: 100%;\r\n}\r\n\r\n#id_text_uppercase{\r\n    text-transform: uppercase;\r\n}\r\n\r\n.textMenu{\r\n    font-weight: normal;\r\n    text-transform: uppercase;\r\n    cursor: pointer;\r\n    white-space: normal !important;\r\n    overflow: visible !important;\r\n    text-overflow: clip !important;\r\n}\r\n\r\n.textMenuSlider{\r\n    font-weight: 500;\r\n    font-size: small;\r\n}\r\n\r\n.container-btns{\r\n    display: flex;\r\n    .mat-mdc-slide-toggle {\r\n        margin-right: 1em;\r\n    }\r\n\r\n    .slide-div{\r\n        display: flex;\r\n        align-items: center;\r\n        border-right: 1px solid black;\r\n    }\r\n    .btnMunicipio{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        padding: 0px 10px;\r\n\r\n        .btn-name-city {\r\n            max-width: 150px;\r\n            text-overflow: ellipsis;\r\n            overflow: hidden;\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.btnUser{\r\n    ::ng-deep .mdc-button__label{\r\n        gap: 10px;\r\n        display: flex;\r\n        align-items: flex-end;\r\n    }\r\n}\r\n\r\n/* responsive desgin */\r\n@media (max-width: 768px) {\r\n    \r\n\r\n    .iconSession{\r\n        float: right;\r\n    }\r\n\r\n    .toolbar {\r\n        background: var(--background-routerActive) !important;\r\n        height: 7vh;\r\n    }\r\n    .logo {\r\n        width: 120px;\r\n        text-align: center;\r\n        margin-left: 6px;\r\n        margin-bottom: 0.3rem;\r\n    }\r\n    .iconMenu {\r\n        color: white;\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    .misAplicaciones {\r\n        transform: scale(1.3);\r\n        padding-right: 10px;\r\n        \r\n        mat-icon {\r\n            color: white;\r\n        }\r\n    }\r\n\r\n    .txusuario{\r\n        display: block;\r\n        font-size: initial;\r\n        color: var(--font-gray);\r\n    }\r\n\r\n    .txmail{\r\n        display: block;\r\n        font-size:xx-small;\r\n        color: var(--font-gray);\r\n    }\r\n\r\n    .sidenavItem {\r\n        padding-left: 6%;\r\n        padding-bottom: 5%;\r\n\r\n        .active-tab {\r\n            color: var(--background-routerActive-submenu);\r\n        }\r\n    }\r\n\r\n    .menuNav{\r\n        width: 92%;\r\n        color: white;\r\n        display: flex;\r\n        margin-top: 10%;\r\n        justify-content: center;\r\n        background: var(--background-routerActive) !important;\r\n    }\r\n\r\n    .container-mat-spinner-icon-location {\r\n        margin-right: 10px;\r\n    }\r\n\r\n    .container-mat-spinner-icon-person {\r\n        margin-left: 10px;\r\n    }\r\n\r\n    .showOrHide{\r\n        transform: rotate(180deg);\r\n    }\r\n\r\n    mat-sidenav-container{\r\n        height: 95%;\r\n        mat-sidenav{\r\n            background-color: rgb(255, 255, 255);\r\n            width: 70%;\r\n        }\r\n        mat-sidenav-content{\r\n            width: 100%;\r\n        }\r\n    }\r\n    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
